import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  Grid,
  TextField
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';
import ProductSKUSearch from '../../components/Selects/ProductSKUSearch';
import RepeatOneIcon from '@material-ui/icons/RepeatOne';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    color: 'white'
  },
  buttonSuccess: {
    position: 'relative',
    float: 'right',
    marginBottom: 10,
    marginLeft: 'auto',
    color: 'white',
    backgroundColor: '#1D3343',
    '&:hover': {
      backgroundColor: '#2f5f82'
    }
  },
  content: {
    minHeight: 130,
    minWidth: 530
  },
  wrapper: {
    '& > div:not(:last-child)': {
      marginBottom: 16
    },
    position: 'relative'
  }
}));

function Substitution({ className, ReceiptNo, readonly, tasks }) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const SessionUser = getUser();
  const [loading, setLoading] = useState(false);
  const [SKU, setSKU] = useState('');
  const [ProductSKU, setProductSKU] = useState('');
  const [ProductYear, setProductYear] = useState('');
  const [ProductMonth, setProductMonth] = useState('');
  const [SerialNumber, setSerialNumber] = useState('');
  const [IssueNote, setIssueNote] = useState('');
  const [ReceiptNote, setReceiptNote] = useState('');
  const [NewWorkOrder, setNewWorkOrder] = useState(0);
  const [notePopUp, setNotePopup] = useState(false);
  const [uyariCiktiNote, setUyariCiktiNote] = useState(false);
  const [uyariAciklamaNote, setUyariAciklamaNote] = useState('');
  const [Required, setRequired] = React.useState(false);
  const [uyariTipCiktiNote, setUyariTipCiktiNote] = useState();
  const today = new Date();
  const YazdirMerkezeGonderData = tasks.tasks.filter(
    d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
  );
  const [FirstIssueType, setFirstIssueType] = useState(0);
  const search = '';
  const [SerialParam, setSerialParam] = React.useState('');
  const maxYil = today.getFullYear();
  const [formValid, setFormValid] = useState(true);
  const [formState, setFormState] = useState([
    {
      name: 'SerialNumber',
      min: 0,
      max: 9999999999,
      valid: true,
      errorMessage: t('error_serino')
    },
    {
      name: 'ProductYear',
      min: 0,
      max: maxYil,
      valid: true,
      errorMessage: t('error_uyil').replace('@maxYil', maxYil)
    },
    {
      name: 'ProductMonth',
      max: 12,
      min: 0,
      valid: true,
      errorMessage: t('error_udonem')
    }
  ]);

  const confirmOkey = msg => {
    confirmAlert({
      message: msg,
      buttons: [
        {
          label: t('Tamam'),
          onClick: () => {}
        }
      ]
    });
  };

  useEffect(() => {
    setFirstIssueType(getFirstIssueType);
  }, []);

  const sendSubstitutionYes = (
    SKU,
    ProductYear,
    ProductMonth,
    SerialNumber,
    IssueNote
  ) => {
    if (
      SKU.length <= 0 ||
      //ProductYear.toString().length <= 0 ||
      //ProductMonth.toString().length <= 0 ||
      //SerialNumber.length <= 0 ||
      IssueNote.length <= 0
    ) {
      setRequired(true);
    }
    // else if (
    //   isNaN(SKU) ||
    //   isNaN(ProductYear) ||
    //   isNaN(ProductMonth) ||
    //   isNaN(SerialNumber)
    // ) {
    //   setUyariAciklamaNote(t('lblEnterNumberMessage'));
    //   setUyariCiktiNote(true);
    // }
    else {
      if (ProductYear == '') {
        ProductYear = 0;
      }
      if (ProductMonth == '') {
        ProductMonth = 0;
      }
      const data = {
        SKU,
        ProductYear: parseInt(ProductYear),
        ProductMonth: parseInt(ProductMonth),
        SerialNumber,
        IssueNote,
        WorkOrderId: parseInt(YazdirMerkezeGonderData[0].ReceiptNo) || 0,
        WorkCaseId: parseInt(YazdirMerkezeGonderData[0].WorkCaseId) || 0,
        EmployeeId: parseInt(YazdirMerkezeGonderData[0].EmployeeId) || 0,
        Notes: YazdirMerkezeGonderData[0].Notes || '',
        UpdateUserId: parseInt(SessionUser.TechnicianId) || 0
      };
      const config = {
        headers: { 'Content-Type': 'application/json' }
      };
      setLoading(true);
      axios
        .post('SetLoanProduct', data, config)
        .then(response => {
          setNewWorkOrder(response.data[0].WorkOrderIdNew);
          setUyariAciklamaNote(
            response.data[0].WorkOrderIdNew + ' - ' + t('lblSubstitutionMessage')
          );
          setUyariTipCiktiNote('success');
          setUyariCiktiNote(true);
          setNotePopup(false);
          setLoading(false);
        })
        .catch(error => {
          confirmOkey(error.message);
          setNotePopup(false);
          setLoading(false);
        });
    }
  };

  const sendSubstitutionYesForReceipt = (
    ReceiptNote
  ) => {
    if (
      ReceiptNote.length <= 0
    ) {
      setRequired(true);
    } else {
      const data = {
        ReceiptNote,
        WorkOrderId: parseInt(YazdirMerkezeGonderData[0].ReceiptNo) || 0,
        WorkCaseId: parseInt(YazdirMerkezeGonderData[0].WorkCaseId) || 0,
        EmployeeId: parseInt(YazdirMerkezeGonderData[0].EmployeeId) || 0,
        Notes: YazdirMerkezeGonderData[0].Notes || '',
        UpdateUserId: parseInt(SessionUser.TechnicianId) || 0
      };
      const config = {
        headers: { 'Content-Type': 'application/json' }
      };
      setLoading(true);
      axios
        .post('SetLoanProductForUpdate', data, config)
        .then(response => {
          setNewWorkOrder(response.data[0].WorkOrderIdNew);
          setUyariAciklamaNote(
            response.data[0].WorkOrderIdNew + ' - ' + t('lblSubstitutionMessage')
          );
          setUyariTipCiktiNote('success');
          setUyariCiktiNote(true);
          setNotePopup(false);
          setLoading(false);
        })
        .catch(error => {
          confirmOkey(error.message);
          setNotePopup(false);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    var WorkCaseId = parseInt(YazdirMerkezeGonderData[0].WorkCaseId)
    axios
      .get(
        '/GetLoanProductForUpdate/' +
        WorkCaseId
      )
      .then(response => {
        const Deger = response.data;
        setSerialNumber(Deger[0].SerialNr);
        setProductYear(Deger[0].ProductionYear);
        setProductMonth(Deger[0].ProductionMonth);
        setSKU(Deger[0].SKU);
        setIssueNote(Deger[0].IssueNote);
      })
      .catch(error => {
        setSerialNumber('');
        setProductYear('');
        setProductMonth('');
        setSKU('');
        setIssueNote('');
      });

  }, []);


  const getFirstIssueType = () => {
    axios
      .get(`/GetFirstIssueType/${ReceiptNo || 0}`)
      .then(response => {
        if (response.data.length > 0 && response.data != '') {
          setFirstIssueType(response.data[0].Type);
        } else {
          setFirstIssueType(0);
        }
      })
      .catch(error => {
        setUyariTipCiktiNote('error');
        setUyariCiktiNote(true);
      });
  };

  const setProduct = param => {
    setSKU(param.ModelCode);
    setProductSKU(param.Dsc);
  };

  const uyariKapatCiktiNote = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyariCiktiNote(false);
  };

  const handleChangeBarcodeParse = Barcode => {

    setUyariCiktiNote(false);
    
    var Sku = SKU;
    var ProductYear = '';
    var ProductMonth = '';
    var SerialNr = '';

    if(SKU.length > 0){
      Sku = SKU;
    }
    else{
      setUyariAciklamaNote(t('lblSKUWarning'));
      setUyariTipCiktiNote('error');
      setUyariCiktiNote(true);
      return
    }

    if (Barcode === '9900000199')
   {
      ProductYear = '1981';
      SerialNr = '1';
      ProductMonth = '1';
      setUyariAciklamaNote(Barcode + '-' + t('lblDummySerialNrWarning'));
      setUyariTipCiktiNote('error');
      setUyariCiktiNote(true);
      setProductMonth(ProductMonth);
      setProductYear(ProductYear);
      setSerialNumber(SerialNr);
      return
    }

    if (SessionUser.TenantId === 59) {
      ProductYear = '1981';
      SerialNr = Barcode;
      ProductMonth = '1';
      setUyariAciklamaNote(Barcode + '-' + t('lblDummySerialNrWarning'));
      setUyariTipCiktiNote('error');
      setUyariCiktiNote(true);
      setProductMonth(ProductMonth);
      setProductYear(ProductYear);
      setSerialNumber(SerialNr);
      return
    }
    setLoading(true);
    axios
      .get(`/ControlSerialNumber/${Sku}/${0}/${Barcode}`)
      .then(response => {
        if (response.data) {
          var serialNumberYear = calculateSerialNumberYear(response.data.ProductionYearRule, Barcode)
          var serialNumberMonth = calculateSerialNumberMonth(response.data.ProductionMonthRule, Barcode)
          var wantedSerialNumber = findOriginalSerialNumber(response.data.SerialNumberRule, Barcode)

          if (serialNumberYear != null && serialNumberMonth != null && wantedSerialNumber != null) {
            setProductMonth(serialNumberMonth);
            setProductYear(serialNumberYear);
            setSerialNumber(wantedSerialNumber);
            setLoading(false);
            return;
          }
        }
        else {
          if (Barcode.length === 10) {
            ProductYear = '20' + Barcode.substring(0, 2);
            SerialNr = Barcode.substring(2, 8);
            ProductMonth = Barcode.substring(8, 10);
            setProductMonth(ProductMonth);
            setProductYear(ProductYear);
            setSerialNumber(SerialNr);
          }
          if (Barcode.length === 14 || Barcode.length === 18) {
            if (Barcode.length === 14) {
              ProductYear = '202' + Barcode.substring(5, 6);
              ProductMonth = Barcode.substring(6, 8);
              SerialNr = Barcode.substring(8, 13);
              setProductMonth(ProductMonth);
              setProductYear(ProductYear);
              setSerialNumber(SerialNr);
            }
            if (Barcode.length === 18) {

              ProductYear = '20' + Barcode.substring(6, 8);
              ProductMonth = Barcode.substring(14, 16);
              SerialNr = Barcode.substring(9, 14);
              setProductMonth(ProductMonth);
              setProductYear(ProductYear);
              setSerialNumber(SerialNr);
            }
          }

          setSerialParam(Barcode);
          if (SessionUser.TenantId !== 78) {
            if (
              ProductYear === '' ||
              ProductMonth === '' ||
              SerialNr === '' ||
              ProductYear === undefined ||
              ProductMonth === undefined ||
              SerialNr === undefined
            ) {
              setUyariAciklamaNote(Barcode + '-' + t('lblInvalidSerialNr'));
              setUyariTipCiktiNote('error');
              setUyariCiktiNote(true);
              ProductYear = '';
              SerialNr = '';
              ProductMonth = '';
              setProductMonth(ProductMonth);
              setProductYear(ProductYear);
              setSerialNumber(SerialNr);
            }
            if (parseInt(ProductMonth) === 0 || parseInt(ProductMonth) > 12) {
              setUyariAciklamaNote(Barcode + '-' + t('lblInvalidSerialNr'));
              setUyariTipCiktiNote('error');
              setUyariCiktiNote(true);
              ProductYear = '';
              SerialNr = '';
              ProductMonth = '';
              setProductMonth(ProductMonth);
              setProductYear(ProductYear);
              setSerialNumber(SerialNr);
            }
            if (
              ProductYear.length !== 4 ||
              parseInt(ProductYear) > parseInt(moment().format('yyyy'))
            ) {
              setUyariAciklamaNote(Barcode + '-' + t('lblInvalidSerialNr'));
              setUyariTipCiktiNote('error');
              setUyariCiktiNote(true);
              ProductYear = '';
              SerialNr = '';
              ProductMonth = '';
              setProductMonth(ProductMonth);
              setProductYear(ProductYear);
              setSerialNumber(SerialNr);
            }
          }
        }
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });


    if (
      SessionUser.TenantId === 9
      || SessionUser.TenantId === 37
      || SessionUser.TenantId === 51
      || SessionUser.TenantId === 56
      || SessionUser.TenantId === 78
    ) {
      return;
    }



  };

  function calculateSerialNumberYear(yearRule, serialNumber) {
    if (yearRule == null || yearRule == undefined) {
      return null
    }
    else if (yearRule.includes(',')) {
      var tempYearRule = yearRule.split(',')
      var result = parseInt('20' + serialNumber[parseInt(tempYearRule[0]) - 1] + serialNumber[parseInt(tempYearRule[1]) - 1])
      return result
    }
    //CONSTANT
    else if (yearRule == '0') {
      var result = 1981
      return result
    }
    else {
      var year = parseInt(serialNumber[parseInt(yearRule) - 1])
      var currentYear = moment().format('yyyy')

      // Yıl Hesaplama için yılın son hanesini gelen yıl kuralının yılından çıkarıyorum
      // Eğer Kalan negatif ise mevcut yılın son hanesine 10 ekliyip yıl kuralından çıkarıp onu da Bütün yıldan çıkarıyorum 
      // örnek: 8 geldi 2'den çıkarıyorum çünkü 2022, 2 - 8 = -6
      // -6 sıfırdan küçük olduğu için 2ye 10 ekliyorum ve 12 - 8 yapıyorum sonucum 4
      // bu elimde ki 4 ise 2022 den çıkarıyorum sonuç 2018

      if (parseInt(currentYear.substring(3)) - year < 0) {
        var result = parseInt(currentYear) - (parseInt(currentYear.substring(3)) + 10 - year)
        return result
      }
      else {
        var result = parseInt(currentYear) - (parseInt(currentYear.substring(3)) - year)
        return result
      }
    }
  }

  function calculateSerialNumberMonth(monthRule, serialNumber) {
    if (monthRule == null || monthRule == undefined) {
      return null
    }
    else if (monthRule.includes(',')) {
      var tempMonthRule = monthRule.split(',')
      var result = parseInt(serialNumber[parseInt(tempMonthRule[0]) - 1] + serialNumber[parseInt(tempMonthRule[1]) - 1])
      if (parseInt(result) > 12) {
        setUyariAciklamaNote(serialNumber + '-' + t('lblInvalidSerialNr'));
        setUyariTipCiktiNote('error');
        setUyariCiktiNote(true);
        return null;
      }
      return result
    }
    else if (monthRule.length == 1 && monthRule != '0') {
      var tempResult = serialNumber[parseInt(monthRule)-1]
      if (Number.isInteger(+tempResult)) {
        return tempResult
      }
      else if (tempResult == 'A') {
        return 10
      }
      else if (tempResult == 'B') {
        return 11
      }
      else if (tempResult == 'C') {
        return 12
      }
    }
    //CONSTANT
    else if (monthRule == '0') {
      var result = 1
      return result
    }
    else {
      return null
    }
  }

  function findOriginalSerialNumber(serialNumberRule, serialNumber) {
    if (serialNumberRule == null || serialNumberRule == undefined) {
      return null
    }
    else if (serialNumberRule.includes(',')) {
      var tempSerialNumberRule = serialNumberRule.split(',')
      if (parseInt(tempSerialNumberRule[1]) - serialNumber.length === 1) {
        var result = serialNumber.substr(parseInt(parseInt(tempSerialNumberRule[0])) - 1, parseInt(parseInt(tempSerialNumberRule[1])) - 1)
        return result
      }
      else if (serialNumber.length !== parseInt(tempSerialNumberRule[1])) {
        setUyariAciklamaNote(serialNumber + '-' + t('lblInvalidSerialNr'));
        setUyariTipCiktiNote('error');
        setUyariCiktiNote(true);
        return null;
      }
      else {
        var result = serialNumber.substr(parseInt(parseInt(tempSerialNumberRule[0])) - 1, parseInt(parseInt(tempSerialNumberRule[1])) - 1)
        return result
      }
    }
    else {
      return null
    }
  }

  const handleChange = e => {
    const { name } = e.target;
    const { value } = e.target;
    let tmpValid = true;
    for (let i = 0; i < formState.length; i++) {
      const obj = formState[i];
      if (obj.name === name && value) {
        if (value > obj.max || value <= obj.min) {
          setFormState([
            ...formState.slice(0, i),
            { ...obj, valid: false },
            ...formState.slice(i + 1)
          ]);
        } else {
          setFormState([
            ...formState.slice(0, i),
            { ...obj, valid: true },
            ...formState.slice(i + 1)
          ]);
        }
      }
      tmpValid = tmpValid && obj.valid;
    }
    setFormValid(tmpValid);
    if (e.target.type === 'checkbox') {
      const value = e.target.checked ? 1 : 0;
      if (name === 'SerialNumber') {
        setSerialNumber(value);
      } else if (name === 'ProductYear') {
        setProductYear(value);
      } else if (name === 'ProductMonth') {
        setProductMonth(value);
      }
    } else {
      const obj = formState.filter(f => f.name === name)[0];
      if (parseInt(value) > obj.min && parseInt(value) <= obj.max) {
        if (name === 'SerialNumber') {
          setSerialNumber(value);
        } else if (name === 'ProductYear') {
          setProductYear(value);
        } else if (name === 'ProductMonth') {
          setProductMonth(value);
        }
      } else {
        if (name === 'SerialNumber') {
          setSerialNumber(obj.min);
        } else if (name === 'ProductYear') {
          setProductYear(obj.min);
        } else if (name === 'ProductMonth') {
          setProductMonth(obj.min);
        }
      }
    }
  };

  if (FirstIssueType == 16) {
    return (
      <Card className={clsx(classes.root, className)}>
        <CardHeader title={t('substitution_title_for_receipt')} />
        {uyariCiktiNote ? (
          <Alert
            onClose={uyariKapatCiktiNote}
            open={uyariCiktiNote}
            message={uyariAciklamaNote || ''}
            variant={uyariTipCiktiNote}
          />
        ) : (
          <div />
        )}
        <Divider />
        <CardContent className={classes.content}>
          {loading ? (
            <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
          ) : (
            <div />
          )}
          <div>
            <div className={classes.wrapper}>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  id="SKU"
                  autoComplete="no"
                  value={SKU ? SKU : ''}
                  fullWidth
                  label={t('lblSKU')}
                  variant="outlined"
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <TextField
                      size="small"
                      name="SerialNumber"
                      autoComplete="no"
                      value={SerialNumber ? SerialNumber : ''}
                      fullWidth
                      label={t('lblSerialNumber')}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      size="small"
                      name="ProductYear"
                      autoComplete="no"
                      value={ProductYear ? ProductYear : ''}
                      fullWidth
                      label={t('lblProductYear')}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      size="small"
                      name="ProductMonth"
                      autoComplete="no"
                      value={ProductMonth ? ProductMonth : ''}
                      fullWidth
                      label={t('lblProductMonth')}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  id="IssueNote"
                  autoComplete="no"
                  value={IssueNote ? IssueNote : ''}
                  fullWidth
                  label={t('lblIssueNote')}
                  variant="outlined"
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  id="ReceiptNote"
                  error={ReceiptNote.length > 0 ? false : Required}
                  required
                  autoComplete="no"
                  value={ReceiptNote ? ReceiptNote : ''}
                  onChange={event => setReceiptNote(event.target.value)}
                  fullWidth
                  label={t('lblReceiptNote')}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  className={classes.buttonSuccess}
                  onClick={() => {
                    sendSubstitutionYesForReceipt(
                      ReceiptNote
                    );
                  }}
                  color="primary"
                  variant="container"
                  disabled={
                    NewWorkOrder !== 0 ? true : false
                  }
                >
                  {t('lblSave')}
                </Button>
              </Grid>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  } else {
    return (
      <Card className={clsx(classes.root, className)}>
        <CardHeader title={t('substitution_title')} />
        {uyariCiktiNote ? (
          <Alert
            onClose={uyariKapatCiktiNote}
            open={uyariCiktiNote}
            message={uyariAciklamaNote || ''}
            variant={uyariTipCiktiNote}
          />
        ) : (
          <div />
        )}
        <Divider />
        <CardContent className={classes.content}>
          {loading ? (
            <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
          ) : (
            <div />
          )}
          <div>
            <div className={classes.wrapper}>
              <Grid item xs={12}>
                <ProductSKUSearch
                  setProduct={setProduct}
                  value={
                    {
                      Dsc: ProductSKU || '',
                      ModelCode: SKU || ''
                    } || ''
                  }
                  error={SKU.length > 0 ? false : Required}
                  searchParam={search}
                  setSKU={setSKU}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Grid container spacing={2}>
                  <Grid item xs={10}>
                    <TextField
                      label={t('lblSerialNr')}
                      name="Barcode"
                      size="small"
                      value={SerialParam || ''}
                      fullWidth
                      onChange={e => setSerialParam(e.target.value)}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      disableElevation
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => handleChangeBarcodeParse(SerialParam || '')}
                    >
                      <RepeatOneIcon />
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <TextField
                      size="small"
                      name="SerialNumber"
                      error={SerialNumber.length > 0 ? false : Required}
                      autoComplete="no"
                      value={SerialNumber ? SerialNumber : ''}
                      onChange={handleChange}
                      fullWidth
                      disabled
                      label={t('lblSerialNumber')}
                      variant="outlined"
                      helperText={
                        formState.filter(n => n.name === 'SerialNumber')[0].valid
                          ? ''
                          : formState.filter(n => n.name === 'SerialNumber')[0]
                            .errorMessage
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      size="small"
                      name="ProductYear"
                      error={ProductYear.toString().length > 0 ? false : Required}
                      autoComplete="no"
                      value={ProductYear ? ProductYear : ''}
                      onChange={handleChange}
                      fullWidth
                      disabled
                      label={t('lblProductYear')}
                      variant="outlined"
                      helperText={
                        formState.filter(n => n.name === 'ProductYear')[0].valid
                          ? ''
                          : formState.filter(n => n.name === 'ProductYear')[0]
                            .errorMessage
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      size="small"
                      name="ProductMonth"
                      error={ProductMonth.toString().length > 0 ? false : Required}
                      autoComplete="no"
                      value={ProductMonth ? ProductMonth : ''}
                      onChange={handleChange}
                      fullWidth
                      disabled
                      label={t('lblProductMonth')}
                      variant="outlined"
                      helperText={
                        formState.filter(n => n.name === 'ProductMonth')[0].valid
                          ? ''
                          : formState.filter(n => n.name === 'ProductMonth')[0]
                            .errorMessage
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  id="IssueNote"
                  error={IssueNote.length > 0 ? false : Required}
                  required
                  autoComplete="no"
                  value={IssueNote ? IssueNote : ''}
                  onChange={event => setIssueNote(event.target.value)}
                  fullWidth
                  label={t('lblIssueNote')}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  className={classes.buttonSuccess}
                  onClick={() => {
                    sendSubstitutionYes(
                      SKU,
                      ProductYear,
                      ProductMonth,
                      SerialNumber,
                      IssueNote
                    );
                  }}
                  color="primary"
                  variant="container"
                  disabled={
                    NewWorkOrder !== 0 ? true : false
                  }
                >
                  {t('lblSave')}
                </Button>
              </Grid>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }
}

Substitution.propTypes = {
  className: PropTypes.string
};

export default connect(state => ({ tasks: state.tasks1 }))(Substitution);
